import { render, staticRenderFns } from "./orderPageSnapshot.vue?vue&type=template&id=5e37817a&scoped=true"
import script from "./orderPageSnapshot.vue?vue&type=script&lang=js"
export * from "./orderPageSnapshot.vue?vue&type=script&lang=js"
import style0 from "./orderPageSnapshot.vue?vue&type=style&index=0&id=5e37817a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37817a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e37817a')) {
      api.createRecord('5e37817a', component.options)
    } else {
      api.reload('5e37817a', component.options)
    }
    module.hot.accept("./orderPageSnapshot.vue?vue&type=template&id=5e37817a&scoped=true", function () {
      api.rerender('5e37817a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/orderPageSnapshot.vue"
export default component.exports